var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"announcement-overview"},[_c(_setup.MStateBox,{attrs:{"loading":_setup.isLoading,"empty":_setup.isEmpty}},[(_setup.currentData.length)?_c(_setup.MobDocumentCard,{attrs:{"listData":_setup.currentData,"showIcon":true},on:{"goToDetail":_setup.handlePreview}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }